import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * 3NODE — keeps the pre-order line properties in the product form in sync
 * with the selected variant (Freelo 31610997).
 *
 * The hidden inputs inside <rf-preorder-property> carry the promised ship
 * date into the cart line ("Dostupnost: Odesíláme koncem října"), so the
 * customer keeps seeing it in the cart, at checkout and in the confirmation
 * e-mail. product-form.js only morphs a fixed list of elements on variant
 * change and this element is not on it — same situation as rf-availability.
 */
class RfPreorderProperty extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(ThemeEvents.variantUpdate, this.updateProperties);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section, dialog')?.removeEventListener(ThemeEvents.variantUpdate, this.updateProperties);
  }

  /**
   * Replaces the hidden inputs with the freshly rendered ones.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateProperties = (event) => {
    // Colour swatches can swap to a different product (combined listing); size
    // changes stay on the same one. Ignore events fired for a product we are
    // not showing.
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const updated = event.detail.data.html.querySelector('rf-preorder-property');

    if (!updated) return;

    morph(this, updated, { childrenOnly: true });
  };
}

if (!customElements.get('rf-preorder-property')) {
  customElements.define('rf-preorder-property', RfPreorderProperty);
}
